import Vue from 'vue'
import Counter from '@/helpers/Counter'

import rowCell from './order-row-cell'
Vue.component(rowCell.name, rowCell)

import afterContent from './order-after-content'
Vue.component(afterContent.name, afterContent)

let counter = new Counter('AdvancedTable')

const UNIQUE_ID_PARAM = '$_unique_id'
const ROW_ID_PREFIX = 'oc-table-row-'

export default {
    slots() {
        return [
            {
                slot: "row-cell",
                component: rowCell.name,
                condition(attrs) {
                    return attrs.col.type === 'OrderColumn'
                }
            },
            {
                slot: "after-content",
                component: afterContent.name,
                condition(attrs) {
                    return this.displayOrderAction && attrs.type === 'PlusMinusColumn'
                }
            }
        ]
    },
    mixins() {
        return {
            props: {
                displayOrderAction: {
                    type: Boolean,
                    default: false
                },
                orderUniqueIdKey: {
                    type: String,
                    default: UNIQUE_ID_PARAM
                },
                orderButton: {
                    type: Object,
                    default: () => ({
                        tag: 'span',
                        attrs: {},
                        text: '&#8597;'
                    })
                }
            },
            watch: {
                data: {
                    immediate: true,
                    handler() {
                        this.generateUniqueIndex()
                    }
                }
            },
            created() {
                require('./css/Table.css') // load global table css

                this.internalRowOptions.push((row) => {
                    return {
                        id: ROW_ID_PREFIX + row[this.orderUniqueIdKey]
                    }
                })
            },
            mounted() {
                if( ! window.jQuery) {
                    console.error('[Table::OrderColumn] Missing dependencies jQuery and jQueryUI.')
                }

                let columnsLength = this.$_columns.length
                let selector = $('table tbody', this.$el)

                selector.sortable({
                    handle: '.node-drag',
                    axis: "y",

                    update: ( event, ui ) => {
                        let rows = this.$_data.slice()
                        let updatedPositions = selector.sortable( "toArray" );

                        let sorted = []
                        for(let i in updatedPositions) {
                            for(let rowIndex in rows) {
                                if ( ROW_ID_PREFIX + rows[rowIndex][this.orderUniqueIdKey] === updatedPositions[i] ) {
                                    sorted.push(rows[rowIndex])
                                }
                            }
                        }

                        this.form.validator().clearUniqueFieldKeyCache()

                        // emit events
                        this.$emit('input', sorted)
                        this.$emit('order', sorted)
                    },

                    stop: function (event, ui) {
                        // revert changes made to the DOM
                        // because they will be handled by Vue
                        $(this).sortable('cancel');
                    },

                    // fix table issue with placeholders
                    placeholder: {
                        element() {
                            return $('<tr class="ui-sortable-placeholder"><td colspan="'+ columnsLength +'">&nbsp;</td></tr>')[0]
                        },
                        update() {}
                    }
                })
            },
            methods: {
                generateUniqueIndex() {
                    for( let row of this.$_data ) {
                        if ( row.hasOwnProperty(UNIQUE_ID_PARAM) ) {
                            continue
                        }

                        Object.defineProperty(row, UNIQUE_ID_PARAM, {
                            value: 'uid-' + counter.increment(),
                            enumerable: false,
                            writable: false
                        })
                    }
                },
                getRowUniqueIndex(row, index) {
                    return row[UNIQUE_ID_PARAM]
                }
            }
        }
    }
}
